import { useTranslation } from "react-i18next";

import { AXON_SITE_URL } from "../constants";
import { Dialog } from "./Dialog";
import { InguzMark } from "./InguzMark";

interface Props {
  open: boolean;
  onClose: () => void;
}

export function AboutDialog({ open, onClose }: Props) {
  const { t } = useTranslation(["about", "common"]);
  const version = import.meta.env.VITE_APP_VERSION ?? "0.0.0";
  const year = new Date().getFullYear();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      icon="info"
      title={t("about:title")}
      width="compact"
      footer={
        <>
          <span />
          <button
            type="button"
            onClick={onClose}
            className="h-footer-btn px-3 inline-flex items-center rounded-sm text-12 font-bold uppercase tracking-widerx text-text-muted hover:text-text-main hover:bg-surface-subtle transition-colors duration-150 focus-visible:outline-none focus-visible:border-brand-primary/60 focus-visible:shadow-[0_0_0_2px_rgb(var(--brand-primary)/0.4)] border border-transparent"
          >
            {t("common:actions.close")}
          </button>
        </>
      }
    >
      <div className="flex flex-col items-center gap-3 text-center text-text-main">
        <span className="text-text-main">
          <InguzMark size={56} />
        </span>

        <div className="flex flex-col items-center gap-1">
          <p className="m-0 text-14 font-bold text-text-main">{t("about:product")}</p>
          <p className="m-0 font-mono text-11 text-text-muted">
            {t("about:versionLabel")} {version}
          </p>
        </div>

        <p className="m-0 text-12 leading-[17px] text-text-muted max-w-[400px]">
          {t("about:description")}
        </p>
      </div>

      <hr className="border-0 border-t border-border-subtle my-1" />

      <div className="flex flex-col gap-2 text-12 text-text-muted">
        <div className="flex items-center justify-between gap-3">
          <span>{t("about:websiteLabel")}</span>
          <a
            href={AXON_SITE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="font-mono text-brand-primary underline underline-offset-2 hover:text-brand-primary/80"
          >
            {t("about:websiteText")}
          </a>
        </div>
        <p className="m-0 font-mono text-11 text-text-muted/70">
          {t("about:copyright", { year })}
        </p>
      </div>
    </Dialog>
  );
}
